import { handleActions } from 'redux-actions';
import WixSDK from 'shared/utils/wix-sdk';
import { attempt } from 'shared/utils/attempt';

export default handleActions({}, {
  compId: attempt(WixSDK.Utils.getOrigCompId) || attempt(WixSDK.Utils.getCompId),
  channelID: state => state.currentChannelId, // cb will be called on each event send with current global state
  iss: 1,
  application: 'Widget',
});



// WEBPACK FOOTER //
// ./src/widget/redux/client/reducers/bi-default-params.js